package com.trevorwiebe.timesheet.loads.presentation.driver

/**
 * The pieces each platform needs to build a labeled maps URL: the raw "lat,lng" pin (URL-safe
 * as-is, null when the location has no pin) plus the percent-encoded location name and
 * name/address search text.
 */
data class MapsLink(
    val latLng: String?,
    val encodedLabel: String,
    val encodedQuery: String,
)
